const CategoriesIndex = () => import('./categories/index.vue');
const CreatePage = () => import('./categories/_pages/create.vue');
const CategoryViewPage = () => import('./categories/_pages/view.vue');

// expenses records
const ExpensesIndex = () => import('./records/index.vue');
const CreateExpensePage = () => import('./records/_pages/create.vue');
const ExpenseViewPage = () => import('./records/_pages/view.vue');

export default [
    {
        path: '/expenses/categories',
        name: 'ExpensesCategories',
        component: CategoriesIndex
    },
    {
        path: '/new-expense-category',
        name: 'NewExpenseCategoryPage',
        component: CreatePage
    },
    {
        path: '/expenses',
        name: 'ExpensesIndex',
        component: ExpensesIndex
    },
    {
        path: '/new-expense',
        name: 'NewExpensePage',
        component: CreateExpensePage
    },
    {
        path: '/expenses-category/:id',
        component: CategoryViewPage
    },
    {
        path: '/expenses/:id',
        component: ExpenseViewPage
    },
]